import { render, staticRenderFns } from "./contract1.vue?vue&type=template&id=4d12996a&scoped=true"
import script from "./contract1.vue?vue&type=script&lang=js"
export * from "./contract1.vue?vue&type=script&lang=js"
import style0 from "./contract1.vue?vue&type=style&index=0&id=4d12996a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12996a",
  null
  
)

export default component.exports